import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOldPersonIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 7.75,
			cy: 2.75,
			r: .75,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M3.5 8L3.75198 6.99209C3.90774 6.36906 4.35321 5.85872 4.94948 5.62021L5.82376 5.2705C6.2268 5.10928 6.68595 5.22886 6.97179 5.55556C8.29121 7.06362 9.40382 7.8818 11.5 8" }),
		/* @__PURE__ */ _jsx("path", { d: "M10.5 8L12 14" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 6L5.5 9.5H7L7.28787 7.48492C7.39983 6.70119 6.79169 6 6 6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M4 14L5.1 12.5333C5.35964 12.1871 5.5 11.7661 5.5 11.3333V9.5M8 14V11.6056C8 11.2107 7.88312 10.8247 7.6641 10.4962L7 9.5" })
	]
});
export default SvgOldPersonIcon;
